module.exports = __webpack_public_path__ + "img/1fie-c-nes.4a1bc735.jpg";